//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import promise from '@/axios/promise'
import {
  BASIC
} from "@/config/constant"
export default {
  name: "editMenu",
  data() {
    return {
      myMenus: [],
      addibleMenus:[]
    }
  },
  methods: {
    getMyMenus: function () {
      promise({
        url: BASIC + '/user/app/menus',
        method: 'get',
      }).then(response => {
        this.myMenus = response;
      });
    },
    getAddibleMenus:function(){
        promise({
            url:BASIC+'/user/app/addiable/menus',
            method:'get'
        }).then(res=>{
            this.addibleMenus=res;
        });
    },
    addMenu:function(menu,index){
         var parentId=menu.parentId;
         var flag=false;
         this.myMenus.forEach(element => {
            var id=element.id;
            if(parentId==id){
              flag=true;
              element.children.push(menu);
              this.addibleMenus.splice(index,1);
            }
         });
         if(!flag){
             promise({
                 url:BASIC+"/menu/"+parentId,
                 method:'get'
             }).then(res=>{
                 var dire=res.data;
                 dire.children=[];
                 dire.children.push(menu);
                 this.myMenus.push(dire);
                 this.addibleMenus.splice(index,1);
             });
         }
    },
    removeMenu:function(direIndex,menuIndex,menu){
       var dire= this.myMenus[direIndex];
       var children=dire.children;
       children.splice(menuIndex,1);
       if(children.length==0){
          this.myMenus.splice(direIndex,1);
       }
       this.addibleMenus.push(menu);
    },
    complete:function(){
      //更新用户菜单
      var menuIds=[];
      $.each(this.myMenus,function(row,dire){
         var children=dire.children;
          $.each(children,function(index,menu){
            menuIds.push(menu.id);
          });
      });
      var self=this;
      promise({
            url:BASIC+"/menu/app/update/menu",
            method:'put',
            params:{jsonStr:JSON.stringify(menuIds)}
        }).then(res=>{
          if(res.code=='0'){
              //返回工作台
              self.$router.push({path:"/"});
          }
        });
    }
  },
  created() {
    this.getMyMenus();
    this.getAddibleMenus();
  }
}



// WEBPACK FOOTER //
// ./src/view/index/menu/editMenu.vue